import { render } from "./TempatAsal.vue?vue&type=template&id=8ca2f7bc&scoped=true"
import script from "./TempatAsal.vue?vue&type=script&lang=js"
export * from "./TempatAsal.vue?vue&type=script&lang=js"

import "./TempatAsal.vue?vue&type=style&index=0&id=8ca2f7bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca2f7bc"]])

export default __exports__